// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Belt_Array = require("@rescript/runtime/lib/js/Belt_Array.js");
let Types__Time = require("../types/Types__Time.bs.js");
let Primitive_int = require("@rescript/runtime/lib/js/Primitive_int.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let AutocompleteV5 = require("../../../v5/autocomplete/AutocompleteV5.bs.js");
let JsxRuntime = require("react/jsx-runtime");

function make(time) {
  return {
    value: time,
    label: Types__Time.to12HourString(time)
  };
}

function getOptionLabel(x) {
  return x.label;
}

function getOptionValue(x) {
  return Types__Time.to24HourString(x.value);
}

let Option = {
  make: make,
  getOptionLabel: getOptionLabel,
  getOptionValue: getOptionValue
};

function makeOptions(startTime, endTime, intervals) {
  let hours = Belt_Array.range(startTime, endTime);
  let minutes = Belt_Array.rangeBy(0, 59, Primitive_int.div(60, intervals));
  return Belt_Array.map(Belt_Array.concatMany(Belt_Array.map(hours, hour => Belt_Array.map(minutes, minute => [
    hour,
    minute
  ]))), param => {
    let time = Types__Time.make(param[0], param[1]);
    return {
      value: time,
      label: Types__Time.to12HourString(time)
    };
  });
}

function TimePicker(props) {
  let onChange = props.onChange;
  let options = makeOptions(props.startTime, props.endTime, props.hourlyIntervals);
  return JsxRuntime.jsx(AutocompleteV5.Select.Single.make, {
    getOptionLabel: getOptionLabel,
    getOptionValue: getOptionValue,
    isClearable: props.isClearable,
    onBlur: props.onBlur,
    onChange: v => onChange(Stdlib_Option.map(v, v => v.value)),
    onFocus: props.onFocus,
    options: options,
    placeholder: props.placeholder,
    value: Stdlib_Option.map(props.value, make)
  });
}

let make$1 = TimePicker;

exports.Option = Option;
exports.makeOptions = makeOptions;
exports.make = make$1;
/* Types__Time Not a pure module */
